export enum ProjectProductTypesAvatarText {
  LON = 0,
  TCP = 2,
  IGR = 3,
}
